var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"100%","text-align":"left"}},[_c('div',{staticClass:"title",staticStyle:{"text-align":"center","margin":"0 0 8px"}},[_vm._v("用户日志")]),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_vm._v("功能完善中")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }